/* Enchanting Charms PDP: add-on stepper, size guide dialog, mobile gallery dots, sticky add to cart.
   Vanilla, no dependencies. Event delegation so it keeps working after Dawn re-renders and in quick add. */
(function () {
  if (window.ecPdpLoaded) return;
  window.ecPdpLoaded = true;

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Silicone stopper add-on ---------- */
  function addonParts(el) {
    var addon = el.closest('[data-ec-addon]');
    if (!addon) return null;
    return {
      addon: addon,
      check: addon.querySelector('[data-ec-addon-check]'),
      input: addon.querySelector('[data-ec-addon-qty]'),
      steps: addon.querySelectorAll('[data-ec-addon-step]'),
      max: parseInt(addon.dataset.max, 10) || 6,
    };
  }

  function syncAddon(p) {
    var on = p.check.checked;
    p.addon.classList.toggle('is-on', on);
    p.input.disabled = !on;
    var val = parseInt(p.input.value, 10) || 1;
    for (var i = 0; i < p.steps.length; i++) {
      var dir = parseInt(p.steps[i].getAttribute('data-ec-addon-step'), 10);
      p.steps[i].disabled = !on || (dir < 0 && val <= 1) || (dir > 0 && val >= p.max);
    }
  }

  function clampAddon(p) {
    var val = parseInt(p.input.value, 10);
    if (!val || val < 1) val = 1;
    if (val > p.max) val = p.max;
    p.input.value = val;
  }

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    if (t.matches('[data-ec-addon-check]') || t.matches('[data-ec-addon-qty]')) {
      var p = addonParts(t);
      if (!p) return;
      clampAddon(p);
      syncAddon(p);
    }
  });

  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('[data-ec-addon-step]') : null;
    if (!btn) return;
    var p = addonParts(btn);
    if (!p || !p.check.checked) return;
    var dir = parseInt(btn.getAttribute('data-ec-addon-step'), 10) || 0;
    p.input.value = (parseInt(p.input.value, 10) || 1) + dir;
    clampAddon(p);
    syncAddon(p);
  });

  /* ---------- Size guide dialog (native <dialog> with fallback) ---------- */
  var lastOpener = null;
  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])';

  function openDialog(dialog, opener) {
    lastOpener = opener || document.activeElement;
    if (typeof dialog.showModal === 'function') {
      if (!dialog.open) dialog.showModal();
    } else {
      dialog.setAttribute('open', '');
      dialog.classList.add('ec-dialog--fallback');
    }
    document.documentElement.classList.add('ec-dialog-lock');
    var close = dialog.querySelector('[data-ec-dialog-close]');
    if (close) close.focus();
  }

  function closeDialog(dialog) {
    if (typeof dialog.close === 'function' && dialog.open) {
      dialog.close();
    } else {
      dialog.removeAttribute('open');
      dialog.classList.remove('ec-dialog--fallback');
      onClosed();
    }
  }

  function onClosed() {
    document.documentElement.classList.remove('ec-dialog-lock');
    if (lastOpener && document.contains(lastOpener)) lastOpener.focus();
    lastOpener = null;
  }

  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var opener = e.target.closest('[data-ec-dialog-open]');
    if (opener) {
      var dialog = document.getElementById(opener.getAttribute('data-ec-dialog-open'));
      if (dialog) {
        e.preventDefault();
        openDialog(dialog, opener);
      }
      return;
    }
    var closer = e.target.closest('[data-ec-dialog-close]');
    if (closer) {
      var d = closer.closest('[data-ec-dialog]');
      if (d) closeDialog(d);
      return;
    }
    // Click on the backdrop (the dialog element itself, outside the panel)
    if (e.target.matches && e.target.matches('[data-ec-dialog][open]')) closeDialog(e.target);
  });

  // Native dialog fires "close" (Esc, form close, .close()); restore focus there.
  document.addEventListener(
    'close',
    function (e) {
      if (e.target && e.target.matches && e.target.matches('[data-ec-dialog]')) onClosed();
    },
    true
  );

  document.addEventListener('keydown', function (e) {
    var dialog = document.querySelector('[data-ec-dialog][open]');
    if (!dialog) return;
    if (e.key === 'Escape' || e.key === 'Esc') {
      if (dialog.classList.contains('ec-dialog--fallback')) {
        e.preventDefault();
        closeDialog(dialog);
      }
      return;
    }
    if (e.key !== 'Tab') return;
    var items = Array.prototype.filter.call(dialog.querySelectorAll(FOCUSABLE), function (el) {
      return el.offsetParent !== null || el === document.activeElement;
    });
    if (!items.length) return;
    var first = items[0];
    var last = items[items.length - 1];
    if (e.shiftKey && (document.activeElement === first || !dialog.contains(document.activeElement))) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && (document.activeElement === last || !dialog.contains(document.activeElement))) {
      e.preventDefault();
      first.focus();
    }
  });

  /* ---------- Mobile gallery dots ---------- */
  var mqMobile = window.matchMedia('(max-width: 749px)');

  function buildDots(gallery) {
    if (gallery.dataset.ecDots === 'done') return;
    var list = gallery.querySelector('[id^="Slider-Gallery-"]');
    if (!list) return;
    var slides = list.querySelectorAll('.product__media-item');
    if (slides.length < 2) return;
    gallery.dataset.ecDots = 'done';

    var wrap = document.createElement('div');
    wrap.className = 'ec-pdp-dots';
    wrap.setAttribute('role', 'group');
    wrap.setAttribute('aria-label', 'Product images');
    var dots = [];
    for (var i = 0; i < slides.length; i++) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'ec-pdp-dots__dot';
      b.setAttribute('aria-label', 'Show image ' + (i + 1) + ' of ' + slides.length);
      b.dataset.index = i;
      b.addEventListener('click', function () {
        var idx = parseInt(this.dataset.index, 10);
        var current = list.querySelectorAll('.product__media-item')[idx];
        if (current) list.scrollTo({ left: current.offsetLeft - list.offsetLeft, behavior: reduceMotion ? 'auto' : 'smooth' });
      });
      wrap.appendChild(b);
      dots.push(b);
    }
    list.parentNode.insertBefore(wrap, list.nextSibling);
    gallery.classList.add('ec-has-dots');

    function update() {
      var w = list.clientWidth || 1;
      var idx = Math.round(list.scrollLeft / w);
      for (var j = 0; j < dots.length; j++) {
        if (j === idx) dots[j].setAttribute('aria-current', 'true');
        else dots[j].removeAttribute('aria-current');
      }
    }
    var ticking = false;
    list.addEventListener(
      'scroll',
      function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () {
          ticking = false;
          update();
        });
      },
      { passive: true }
    );
    update();
  }

  function initGalleries() {
    var galleries = document.querySelectorAll('product-info.ec-pdp:not([data-original-section]) media-gallery');
    for (var i = 0; i < galleries.length; i++) buildDots(galleries[i]);
  }

  /* ---------- Sticky add to cart (mobile) ---------- */
  function initSticky() {
    var bar = document.querySelector('[data-ec-sticky]');
    if (!bar || bar.dataset.ecReady) return;
    var info = document.querySelector('product-info.ec-pdp[id^="MainProduct-"]');
    if (!info) return;
    var form = info.querySelector('product-form');
    var submit = info.querySelector('product-form [type="submit"]');
    var anchor = info.querySelector('.product-form__buttons') || submit;
    if (!form || !submit || !anchor) return;
    bar.dataset.ecReady = 'true';

    var btn = bar.querySelector('[data-ec-sticky-btn]');
    var btnText = bar.querySelector('[data-ec-sticky-label]');
    var priceEl = bar.querySelector('[data-ec-sticky-price]');
    var mode = bar.dataset.mode;

    function syncButton() {
      if (mode !== 'add') return;
      var label = submit.querySelector('span');
      var disabled = submit.hasAttribute('disabled');
      btn.disabled = disabled;
      if (label && btnText) btnText.textContent = label.textContent.trim();
    }

    function syncPrice() {
      if (!priceEl) return;
      var price = info.querySelector('[id^="price-"] .price');
      if (!price) return;
      var el = price.classList.contains('price--on-sale')
        ? price.querySelector('.price__sale .price-item--sale')
        : price.querySelector('.price__regular .price-item--regular');
      if (el && el.textContent.trim()) priceEl.textContent = el.textContent.trim();
    }

    syncButton();
    new MutationObserver(syncButton).observe(submit, { attributes: true, childList: true, subtree: true, characterData: true });
    var priceWrap = info.querySelector('[id^="price-"]');
    if (priceWrap) new MutationObserver(syncPrice).observe(priceWrap, { childList: true, subtree: true });

    btn.addEventListener('click', function () {
      if (mode === 'add') {
        if (!submit.hasAttribute('disabled')) submit.click();
        return;
      }
      // Choose mode: take the shopper to the options so the size/letter is a conscious pick.
      var picker = info.querySelector('variant-selects') || anchor;
      var top = picker.getBoundingClientRect().top + window.pageYOffset - 120;
      window.scrollTo({ top: top, behavior: reduceMotion ? 'auto' : 'smooth' });
      var focusTarget = picker.querySelector('input:checked') || picker.querySelector('input, select');
      if (focusTarget) {
        setTimeout(function () {
          try {
            focusTarget.focus({ preventScroll: true });
          } catch (err) {
            focusTarget.focus();
          }
        }, reduceMotion ? 0 : 450);
      }
    });

    function setVisible(show) {
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      if (show) bar.removeAttribute('inert');
      else bar.setAttribute('inert', '');
      document.body.classList.toggle('ec-sticky-on', show);
    }

    // Show only once the main buttons have scrolled up and out of view.
    // A scroll check (not IntersectionObserver) so a fast flick past the buttons can't skip it.
    var ticking = false;
    var shown = null;
    function check() {
      ticking = false;
      var show = anchor.getBoundingClientRect().bottom < 0;
      if (show !== shown) {
        shown = show;
        setVisible(show);
      }
    }
    function onScroll() {
      if (!ticking) {
        ticking = true;
        window.requestAnimationFrame(check);
      }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    check();
  }

  function init() {
    initGalleries();
    initSticky();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  // Re-run after Dawn swaps product HTML (variant that changes product, theme editor reloads).
  document.addEventListener('shopify:section:load', function () {
    window.setTimeout(init, 50);
  });
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, function () {
      window.setTimeout(initGalleries, 50);
    });
  }
  if (mqMobile.addEventListener) mqMobile.addEventListener('change', initGalleries);
})();
